<form class="delete-request-program-eval-modal-root">
  <div class="title">
    <app-label isBig>{{labels.programEvaluation}}</app-label>
    <button id="close-modal-icon" (click)="closeClick()" mat-icon-button class="close-button">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <app-label class="black label">{{labels.howMuchRecommend}}</app-label>
  <div class="recommend-range">
    <div class="recommend-level-wrapper" *ngFor="let n of recommendRange">
      <app-primary-button class="recommend-level" [stroked]="!isActiveRecommendLevel(n)" (clickAction)="setRecommendLevel(n)">
        {{n}}
      </app-primary-button>
    </div>
  </div>
  <div class="recommend-description">
    <app-label isGray>{{labels.bad}}</app-label>
    <app-label isGray>{{labels.best}}</app-label>
  </div>
  <app-label class="black label">{{labels.doYouHaveProblemWithProgram}}</app-label>
  <div class="radio-button">
    <input type="radio" name="program-problem" id="rewards-problem" value="rewards" [formControl]="programProblemControl">
    <label for="rewards-problem">{{labels.rewards}}</label>
  </div>
  <div class="radio-button">
    <input type="radio" name="program-problem" id="warranty-problem" value="warranty" [formControl]="programProblemControl">
    <label for="warranty-problem">{{labels.warranty}}</label>
  </div>
  <div class="radio-button">
    <input type="radio" name="program-problem" id="maintenance-problem" value="maintenance" [formControl]="programProblemControl">
    <label for="maintenance-problem">{{labels.maintenance}}</label>
  </div>
  <div class="radio-button">
    <input type="radio" name="program-problem" id="other-problem" value="other" [formControl]="programProblemControl">
    <label for="other-problem">{{labels.other}}</label>
  </div>
  <app-label class="black label">{{labels.tellWhatHappened}}</app-label>
  <app-input type="textarea" [label]="labels.optionalExplanation" [control]="feedbackControl"></app-input>
  <div mat-dialog-actions>
    <app-primary-button class="success-button"
                        id="send-delete-request-btn"
                        mat-button
                        wrapped
                        type="submit"
                        [abstractControl]="form"
                        [disabled]="loading"
                        (clickAction)="sendDeleteRequest()">
      {{ labels.sendAccountDeleteRequest }}
    </app-primary-button>
    <app-primary-button id="fail-dialog-btn"
                        mat-button
                        [disabled]="loading"
                        (clickAction)="closeClick()">
      {{ labels.cancel }}
    </app-primary-button>
  </div>
</form>

